import { Button, Paper, Stack, Typography } from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import { TextField } from '../../components';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { BASE_URL } from '../../utils';
import axios from 'axios';
import { toast } from '../../utils'; // Assuming you have a toast utility

export const Activation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchRolesData = async () => {
      try {
        const response = await axios.post(`${BASE_URL}/activation`);
        if (response.status === 200) {
          alert(response.data.message);
          navigate('/');
        }
      } catch (error) {
        console.error('Error fetching roles:', error);
      }
    };

    fetchRolesData();
  }, []);

  // Initialize the useForm hook
  const methods = useForm();

  // Form submission handler
  const handleSubmit = async (formValues) => {
    setLoading(true); // Set loading state to true
    try {
      // Send login request to the authentication API
      const loginResponse = await axios.post('https://hms-admin-panel.vercel.app/api/activation', formValues);

      // Check if login was successful
      if (loginResponse.data.success) {
        const userData = loginResponse.data.data; // Get data from the login response

        // Send the user data to the backend to store in MongoDB
        const storeResponse = await axios.post(`${BASE_URL}/adminUsers`, {
          data: userData
        });

        if (storeResponse.data.success) {
          toast('Admin user created successfully!', { variant: 'success' });
          navigate('/'); // Redirect to a different page after activation
        } else {
          toast(storeResponse.data.message || 'Creation failed!', { variant: 'error' });
        }
      } else {
        toast(loginResponse.data.message || 'Login failed!', { variant: 'error' });
      }
    } catch (error) {
      toast('Something went wrong!', { variant: 'error' });
    } finally {
      setLoading(false); // Set loading state to false after request completion
    }
  };

  return (
    <Paper
      sx={{
        width: 'clamp(30rem, 50%, 40rem)',
        mx: 'auto',
        my: 7,
        p: 3,
        backgroundColor: 'transparent',
        backdropFilter: 'blur(5rem)',
        borderRadius: '1.5rem',
        height: '30rem'
      }}
    >
      <Typography variant="h3" gutterBottom color="common.white" textAlign="center">
        Activation
      </Typography>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSubmit)}>
          <Stack spacing={2}>
            <TextField name="email" placeholder="Email" />
            <TextField name="password" placeholder="Password" type="password" />
          </Stack>
          <Button disabled={loading} fullWidth sx={{ mt: 3 }} variant="contained" color="primary" type="submit">
            Submit
          </Button>
        </form>
      </FormProvider>
    </Paper>
  );
};
